import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { getStoredReferralCode } from '../utils/referralCookies';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  if (!isAuthenticated) {
    // Visitors who arrived via an affiliate `?ref=` link (stored in the
    // `s2g_ref` cookie) are sent to registration instead of login.
    return <Navigate to={getStoredReferralCode() ? '/register' : '/login'} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 